import { PlusCircleIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { DiscriminatedDeliverableMatchCreatedEvent } from '@/services/api/generated/matterChangesService';

import {
  ActivityBody,
  ActivityIcon,
  ActivityItem,
  ActivityTitle,
} from '../activity-feed-v2';
import { getUserFromEvent } from '../activity-feed-v2/ActivityDiffList';

export interface DeliverableMatchCreatedEventProps {
  event: DiscriminatedDeliverableMatchCreatedEvent;
}

export const DeliverableMatchCreatedEvent: React.FC<
  DeliverableMatchCreatedEventProps
> = ({ event }) => {
  const { deliverable } = event.payload;
  const user = getUserFromEvent(event);

  const icon = (
    <ActivityIcon
      icon={
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-cyan-100">
          <PlusCircleIcon className="h-4 w-4 text-cyan-600" />
        </div>
      }
    />
  );

  const body = (
    <ActivityBody>
      {deliverable?.name && <ActivityTitle>{deliverable.name}</ActivityTitle>}
    </ActivityBody>
  );

  return (
    <ActivityItem
      icon={icon}
      title="Deliverable Match Created"
      timestamp={new Date(event.occurred_at ?? new Date())}
      user={user}
      body={body}
    />
  );
};
